function TabelaEntradas({ dados }) {
  if (!dados || dados.length === 0) {
    return (
      <div className="sem-dados">
        <p>Nenhuma entrada encontrada sem DFE emitido.</p>
      </div>
    );
  }

  return (
    <div className="tabela-container">
      <table className="tabela-dfes-detalhes">
        <thead>
          <tr>
            <th>Cliente/Cliente Financeiro</th>
            <th>Descrição</th>
            <th>Valor</th>
            <th>Data Pagamento</th>
            <th>Data Limite</th>
            <th>Método</th>
            <th>DFE em Falta</th>
          </tr>
        </thead>
        <tbody>
          {dados &&
            dados.map((entrada) => (
              <tr key={entrada._id}>
                <td>
                  {entrada.tipo === "reembolso" && entrada.cliente?._id ? (
                    <a
                      href={`/clientes/${entrada.cliente._id}`}
                      className="link-cliente"
                    >
                      {entrada.cliente.nome}
                    </a>
                  ) : entrada.tipo === "reembolso" && entrada.cliente ? (
                    entrada.cliente.nome
                  ) : entrada.clienteFornecedor ? (
                    entrada.clienteFornecedor.nome
                  ) : (
                    "N/A"
                  )}
                </td>
                <td>{entrada.descricao || "N/A"}</td>
                <td>{entrada.valor?.toLocaleString("pt-Br")}CVE</td>
                <td>
                  {entrada.dataPagamento
                    ? new Date(entrada.dataPagamento).toLocaleDateString(
                        "pt-PT"
                      )
                    : "-"}
                </td>
                <td>
                  {entrada.dataLimitePagamento
                    ? new Date(entrada.dataLimitePagamento).toLocaleDateString(
                        "pt-PT"
                      )
                    : "-"}
                </td>
                <td>{entrada.metodoPagamento || "N/A"}</td>
                <td>
                  <div className="dfe-status">
                    {entrada.tipo === "reembolso" ? (
                      <span className="badge badge-dfe badge-fre">FRE / TVE</span>
                    ) : entrada.documentoEletronico ? (
                      <span className="badge badge-dfe badge-rce">RCE</span>
                    ) : (
                      <span className="badge badge-dfe badge-fte">FTE</span>
                    )}
                    {entrada.dfePendente === "erro" && (
                      <span className="badge badge-dfe badge-erro">⚠ Erro na emissão</span>
                    )}
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}

export default TabelaEntradas;
